import React from 'react';
import styled from 'styled-components';
import { cssColorValue, HorizontalRule, semanticColors, spacer12, spacer40 } from '@spotify-internal/encore-web/core';

import { SideMenuNavigationItem, SideMenuNavigationLink } from 'components/Masthead/Header/SideMenu/Shared';
import { MastheadLinkOrLinkListArray } from 'lib/sanity/types';
import { isMastheadLink } from 'utils/type-guards';

const MenuSeparator = styled(HorizontalRule)`
  border-color: ${cssColorValue(semanticColors.essentialBase)};
  border-width: 1px;
  margin: ${spacer12} 0;
  width: ${spacer40};
`;

type Props = {
  secondaryLinks?: MastheadLinkOrLinkListArray;
  closeBackdrop: () => void;
};

export const SideMenuSecondaryLinks = ({ secondaryLinks, closeBackdrop }: Props) => {
  if (!secondaryLinks || secondaryLinks.length === 0) {
    return null;
  }

  return (
    <>
      {secondaryLinks.filter(isMastheadLink).map(item => (
        <SideMenuNavigationItem onClick={closeBackdrop} key={item.title}>
          <SideMenuNavigationLink href={item.href} onClick={closeBackdrop} target={item.target}>
            {item.title}
          </SideMenuNavigationLink>
        </SideMenuNavigationItem>
      ))}
      <SideMenuNavigationItem>
        <MenuSeparator />
      </SideMenuNavigationItem>
    </>
  );
};
